import React from 'react'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import AspectRatio from 'components/utils/AspectRatio'
import { connect } from 'react-redux'
import { ImageParams } from 'components/Common/ResponsiveImage'
import PrimaryButtonPaletteProvider from 'contexts/PrimaryButtonPaletteProvider'
import PaletteProvider from 'contexts/PaletteProvider'
import PartnershipLabel from 'components/Luxkit/Label/PartnershipLabel'
import { VIRGIN_VELOCITY_PARTNERSHIP_CODE } from 'constants/partnerships'
import HeroCruiseOfferDetails from './HeroCruiseOfferDetails'
import ImageCarousel from 'components/Luxkit/Carousel/ImageCarousel'
import HeroOfferTileWrapper from './HeroOfferTileWrapper'

interface MappedProps {
  isVelocityEnabled: boolean;
}

interface Props {
  offer: App.CruiseOffer;
  eagerLoadFirstImage?: boolean;
  offerUrl: string;
}

const imageParams: ImageParams = {
  mobileAspectRatio: '3:2',
  tabletAspectRatio: '16:9',
  desktopAspectRatio: '19:9',
  desktopWidth: '67vw',
  largeDesktopWidth: '750px',
  quality: 'good',
}

function HeroCruiseOfferTile(props: Props & MappedProps) {
  const {
    offer,
    eagerLoadFirstImage,
    isVelocityEnabled,
  } = props

  const { images } = offer

  return (
    <PrimaryButtonPaletteProvider palette="default">
      <HeroOfferTileWrapper>
        <AspectRatio ratio="3:2" tabletRatio="16:9" desktopRatio="19:9" fillHeight>
          <ImageCarousel
            images={images}
            imageParams={imageParams}
            eagerLoadFirstImage={eagerLoadFirstImage}
            topLeft={isVelocityEnabled && <PartnershipLabel canEarn canUse variant="icon" />}
            topRight={<TripGuard>
              <CSSBreakpoint max="tablet">
                <PaletteProvider type="default">
                  <BookmarkButton offer={offer} />
                </PaletteProvider>
              </CSSBreakpoint>
            </TripGuard>}
          />
        </AspectRatio>
        <CSSBreakpoint max="tablet">
          <HeroCruiseOfferDetails offer={offer} isDesktop={false}/>
        </CSSBreakpoint>
        <CSSBreakpoint min="desktop">
          <HeroCruiseOfferDetails offer={offer} isDesktop />
        </CSSBreakpoint>
      </HeroOfferTileWrapper>
    </PrimaryButtonPaletteProvider>
  )
}

const mapStateToProps = (state: App.State): MappedProps => ({
  isVelocityEnabled: state.geo.partnership?.code === VIRGIN_VELOCITY_PARTNERSHIP_CODE,
})

export default connect(mapStateToProps)(HeroCruiseOfferTile)
